import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";
import { ReportWithWorksheet } from "@/components/ReportWithWorksheet";
import { ProgressSections } from "@/pages/PersonReport";

export default function PublicReport() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/public/report/${token}`)
      .then((r) => setData(r.data))
      .catch((e) =>
        setError(e?.response?.status === 404 ? "This report link is not valid." : "We couldn't load this report right now. Please try again shortly.")
      );
  }, [token]);

  return (
    <div className="min-h-screen px-4 py-8 sm:py-14">
      <div className="mx-auto max-w-5xl">
        {error && <p data-testid="public-report-error" className="text-center text-slate-600">{error}</p>}
        {!data && !error && <Loader2 className="mx-auto h-6 w-6 animate-spin text-[#1F4266]" />}
        {data && (
          <ReportWithWorksheet data={data} max={data.max_score} token={token} editable>
            {data.history?.length > 0 && <ProgressSections entries={data.history} who="you" />}
          </ReportWithWorksheet>
        )}
      </div>
    </div>
  );
}
